module.exports = __webpack_public_path__ + "static/media/qa-testing.1312b17b.png";